import script from "./CampaignEmailForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./CampaignEmailForm.vue?vue&type=script&setup=true&lang=ts"

import "./CampaignEmailForm.vue?vue&type=style&index=0&id=4b415b61&scoped=true&lang=css"
import "./CampaignEmailForm.vue?vue&type=style&index=1&id=4b415b61&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b415b61"]])

export default __exports__